import React from "react";
import { Col, Row } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import { ErrorMessages, InputBox } from "../../components";

import { ApiHelper, FeedInterface, SubscriptionInterface, UserHelper, } from "../../helpers";


interface Props {
  feed: FeedInterface
}



export const ManageFeed: React.FC<Props> = props => {

  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const [subscription, setSubscription] = React.useState<SubscriptionInterface>(null);
  const [errors, setErrors] = React.useState<string[]>([]);
  const [redirect, setRedirect] = React.useState("");

  const init = () => {
    ApiHelper.get("/subscriptions/feed/" + props.feed?.id).then((data) => {
      setSubscription(data);
    });
  }

  React.useEffect(init, [props.feed])

  const handleSubscribe = () => {
    if (UserHelper.checkAccess("owner")) {
      setIsSubmitting(true);
      ApiHelper.post("/feeds/" + props.feed.id + "/subscribe", {}).then(data => {
        init();
        setIsSubmitting(false);
      });
    } else alert("Unable to subscribe since you are not the account owner.");
  }

  const handleUnsubscribe = () => {
    if (UserHelper.checkAccess("owner")) {
      setIsSubmitting(true);
      ApiHelper.post("/feeds/" + props.feed.id + "/unsubscribe", {}).then(data => {
        if (data.errors) setErrors(data.errors);
        else { setErrors([]); init(); }
        setIsSubmitting(false);
      });
    } else alert("Unable to subscribe since you are not the account owner.");
  }

  const getPriceDetails = () => {
    let formatter = Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })
    let displayPrice = <></>;
    let trial = <></>;
    if ((props.feed.monthlyAccountFee > 0 || props.feed.additionalScreenFee > 0) && props.feed.trialDays > 0) trial = <><br />{props.feed.trialDays} day free trial</>
    if (props.feed.monthlyAccountFee === 0 && props.feed.additionalScreenFee === 0) displayPrice = <h4>Free</h4>;
    else if (props.feed.additionalScreenFee === 0) {
      displayPrice = <>
        <b>{formatter.format(props.feed.monthlyAccountFee)}</b><br />
        <i>Unlimited Screens</i>
        {trial}
      </>;
    }
    else if (props.feed.monthlyAccountFee === 0 && props.feed.additionalScreenFee > 0) {
      displayPrice = <>
        First Screen: <b>Free</b><br />
        Additional Screens: <b>{formatter.format(props.feed.additionalScreenFee)}/mo</b>
        {trial}
      </>;
    } else {
      displayPrice = <>
        First Screen: <b>{formatter.format(props.feed.monthlyAccountFee)}/mo</b>
        Additional Screens: <b>{formatter.format(props.feed.additionalScreenFee)}/mo</b>
        {trial}
      </>;
    }
    return (<Row>
      <Col sm={4}><h4>Price:</h4></Col>
      <Col sm={8}>{displayPrice}</Col>
    </Row>);
  }

  const createPlaylist = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const shape: string = urlParams.get("shape");
    if (!shape) setRedirect("/playlists/0?subscriptionId=" + subscription.id);
    else setRedirect("/playlists/0?subscriptionId=" + subscription.id + "&shape=" + shape);
  }

  if (redirect !== "") return <Redirect to={redirect} />
  else if (subscription) {
    const hasPlaylist = props.feed.mode === "Playlist" || props.feed.mode === "Both";
    const hasLibrary = props.feed.mode === "Library" || props.feed.mode === "Both";
    const saveFunction = (hasPlaylist) ? createPlaylist : null;
    const saveText = (hasPlaylist) ? "Create Playlist" : null;

    const libraryMessage = (hasLibrary) ? <p>The messages from this feed are available to add to any playlist.</p> : <></>

    return (
      <InputBox headerIcon="fas fa-satellite-dish" headerText="Manage Feed" deleteText="Unsubscribe" deleteFunction={handleUnsubscribe} isSubmitting={isSubmitting} saveText={saveText} saveFunction={saveFunction} >
        <>
          <ErrorMessages errors={errors} />
          {getPriceDetails()}
          {libraryMessage}

        </>
      </InputBox>
    );
  } else {
    return (
      <InputBox headerIcon="fas fa-satellite-dish" headerText="Manage Feed" saveText="Subscribe" saveFunction={handleSubscribe} isSubmitting={isSubmitting} >
        <>
          <ErrorMessages errors={errors} />
          {getPriceDetails()}
        </>
      </InputBox>
    );
  }

};